import { createSelector } from 'reselect'
import getSubtotalCartSelector from 'modules/cart/redux/selectors/get-subtotal'
import { getSubtotalRemainingBeforeAovUnlockProductVariantSelectorUtil } from 'modules/product-variant/redux/selectors/get-subtotal-remaining-before-aov-unlock/utils'

/**
 * @param aovLock
 * @returns {*}
 */
export const getSubtotalRemainingBeforeAovUnlockProductVariantSelector = ({ aovLock }) => createSelector(
  getSubtotalCartSelector(),
  (
    subtotal
  ) => getSubtotalRemainingBeforeAovUnlockProductVariantSelectorUtil({
    aovLock,
    subtotal
  })
)
